'use client';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CircularProgress from '@mui/material/CircularProgress/CircularProgress';
import Box from '@mui/system/Box/Box';
import { Wrap } from 'link/src/components/wrap';
import theme from 'link/src/theme';

export default function Loading() {
    const { t } = useTranslation('restaurantAdmin.smart.banner');

    return (
        <>
            <Wrap>
                <>
                    <CircularProgress color="primary" />
                    <Box sx={{ fontFamily: theme.typography.fontFamily }}>{t('loading')}</Box>
                </>
            </Wrap>
        </>
    );
}
